import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import './index.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import ImportPage from './pages/ImportPage';
import ReportsPage from './pages/ReportsPage';
import CustomersPage from './pages/CustomersPage';
import LogPage from './pages/LogPage';
import CustomerView from './pages/CustomerView';
import ConfirmPage from './pages/ConfirmPage';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';

function Sidebar() {
  const { user, signOut } = useAuth();
  const navItems = [
    { to: '/import', icon: '⬆', label: 'Import' },
    { to: '/reports', icon: '📋', label: 'Reports' },
    { to: '/customers', icon: '🏢', label: 'Customers' },
    { to: '/log', icon: '📜', label: 'Send Log' },
  ];
  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img src="/nimble-flag-dark.png" alt="Nimble"
             style={{width:140, display:'block', marginBottom:8}} />
        <div className="app-name">Customer Updates</div>
      </div>
      <nav className="sidebar-nav">
        {navItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div style={{fontSize:11, color:'var(--text-secondary)',
                     marginBottom:8}}>{user?.email}</div>
        <button
          onClick={signOut}
          style={{background:'none', border:'1px solid var(--border)',
                  borderRadius:4, padding:'4px 10px', fontSize:11,
                  cursor:'pointer', color:'var(--text-secondary)',
                  width:'100%'}}
        >Sign out</button>
        <div style={{marginTop:8}}>nimbleinc.net</div>
      </div>
    </aside>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{display:'flex', alignItems:'center', justifyContent:'center',
                 minHeight:'100vh'}}>
      <p style={{color:'#6b7280'}}>Loading...</p>
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/view/:token" element={<CustomerView />} />
          <Route path="/confirm/:token" element={<ConfirmPage />} />

          {/* PROTECTED INTERNAL APP */}
          <Route path="*" element={
            <ProtectedRoute>
              <div className="app-shell">
                <Sidebar />
                <main className="main-content">
                  <Routes>
                    <Route path="/" element={<ImportPage />} />
                    <Route path="/import" element={<ImportPage />} />
                    <Route path="/reports" element={<ReportsPage />} />
                    <Route path="/customers" element={<CustomersPage />} />
                    <Route path="/log" element={<LogPage />} />
                  </Routes>
                </main>
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
